<template>
  <div class="goPrePage" @click="$router.go(-1)">
    <el-tooltip
      class="item"
      effect="dark"
      content="返回上一页"
      placement="left"
    >
      <i class="iconfont icon-fanhui" style="color: #444;"></i>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style scoped lang='less'>
.goPrePage {
  position: fixed;
  width: 40px;
  height: 40px;
  border-radius: 4px;
  background-color: #e7eaf1;
  right: 10px;
  // bottom: 100px;
  bottom: 40%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2030;
  cursor: pointer;
  i {
    font-size: 24px;
    font-weight: bold;
  }
}
</style>